/* eslint-disable */

export const TK_ACTION_INIT = 'Iniciar';

export const TK_CATEGORY_BEHAVIOR = '(V4) Comportamento';
export const TK_CATEGORY_PROFILE = '(V4) Perfil';
export const TK_CATEGORY_SERVICE_SELECT = '(V4) Seleção de Serviço';

export const TK_TIPOS_ACAO_SELECAO_SERVICO = {
    "MENU": "Por Menu",
    "HIGHLIGHT": "Por Highlight",
    "FUNCIONALIDADE": "Por Funcionalidade",
    "PEDIDO": "Por Novo Pedido",
    "PESQUISA": "Por Pesquisa",
    "LOGOUT": "Por Logout HL",
}

import configuration from '../../envConfig';

export const trackProfileORA = (type, value) => {

    (function () {
        var cxDataObject = {
            "wt.event_name": TK_CATEGORY_PROFILE,
        }

        if (type) {
            cxDataObject["wt.event_type"] = type;
            if (value && value != "") {
                cxDataObject["wt.event_value"] = value;
            }
        }

        window.ORA = window.ORA || { productReady: [] };
        ORA.productReady.push(['analytics', function (cxDataObject) { return function () { return ORA.click({ "data": cxDataObject }) } }(cxDataObject)]);
    })();
}

export const trackBehaviourORA = (action) => {

    (function () {
        var cxDataObject = {
            "wt.event_name": TK_CATEGORY_BEHAVIOR,
        }

        if (action) {
            cxDataObject["wt.event_action"] = action;
        }

        window.ORA = window.ORA || { productReady: [] };
        ORA.productReady.push(['analytics', function (cxDataObject) { return function () { return ORA.click({ "data": cxDataObject }) } }(cxDataObject)]);
    })();
}

export const trackServiceSelectORA = (action, name) => {

    (function () {
        var cxDataObject = {
            "wt.event_name": TK_CATEGORY_SERVICE_SELECT,
        }

        if (action) {
            cxDataObject["wt.event_action"] = action;
            if (name && name != "") {
                cxDataObject["wt.service_name"] = name;
            }
        }

        window.ORA = window.ORA || { productReady: [] };
        ORA.productReady.push(['analytics', function (cxDataObject) { return function () { return ORA.click({ "data": cxDataObject }) } }(cxDataObject)]);
    })();
}
